import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useDataSource from '@afosto/app-components-react/DataSource/useDataSource';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import DataList from '@afosto/app-components-react/DataList';
import ProductLine from '@afosto/app-components-react/ProductLine';
import ProductLineSkeleton from '@afosto/app-components-react/ProductLine/ProductLineSkeleton';
import fetchMultipleProducts from '@afosto/utils-react/fetchMultipleProducts';
import translations from './translations';

const DataListContainerGrid = props => <Grid container spacing={1} justify="center" {...props} />;

const PositionProductList = ({ locationPosition }) => {
  const intl = useIntl();
  const { code } = locationPosition ?? {};

  const fetchProducts = async () => {
    try {
      const skus = locationPosition?.skus.map(result => result.sku);
      let products = [];

      if (skus.length > 0) {
        products = await fetchMultipleProducts(skus);
      }

      return products;
    } catch (err) {
      return [];
    }
  };

  const dataSource = useDataSource(fetchProducts, {
    modules: ['dataProperties'],
  });
  const dataSourceRef = useRef(dataSource);

  useEffect(() => {
    dataSourceRef.current = dataSource;
  });

  useEffect(() => {
    dataSourceRef.current.reloadDataSource();
  }, [code]);

  const renderProduct = product => (
    <Grid item key={product?.id} xs={12}>
      <Card>
        <CardContent>
          <ProductLine
            item={{ product, description: product?.name, ean: product?.ean, sku: product?.sku }}
          />
        </CardContent>
      </Card>
    </Grid>
  );

  const renderProductSkeleton = key => (
    <Grid item key={key} xs={12}>
      <Card key={key}>
        <CardContent>
          <ProductLineSkeleton />
        </CardContent>
      </Card>
    </Grid>
  );

  return (
    <DataList
      dataSource={dataSource}
      renderItem={renderProduct}
      renderSkeletonItem={renderProductSkeleton}
      component={DataListContainerGrid}
      emptyMessage={intl.formatMessage(translations.emptyMessage)}
    />
  );
};

PositionProductList.propTypes = {
  locationPosition: PropTypes.object,
};

PositionProductList.defaultProps = {
  locationPosition: undefined,
};

export default PositionProductList;
